const KEY = "si2t_contact_prefill";

export const setPrefill = (data) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (_) {
    /* storage unavailable */
  }
  window.dispatchEvent(new CustomEvent("si2t:prefill", { detail: data }));
};

export const takePrefill = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};
